import React, { useEffect, useState, useRef } from 'react';
import { useIsVisible } from 'react-is-visible';
import DBHandler from '../../javascript/index-db/db-handler';
import style from './ad-image-style.module.scss';
import { SPORT_BASE } from '../../javascript/services/globalVars';
import { Wait_For_Auth } from '../../javascript/utils/utils';
import { SME_AUTH } from '../../javascript/services/globalVars';
import { AdDisplayTool } from "sme-util-module";




const dbHandler = DBHandler();
// var image_list = [];

function AdImage() {
   const wrapper = useRef();
   const isVisible = useIsVisible(wrapper);
   const [api, setAPI] = useState(() => '');
   const [graphql, setGraphql] = useState(() => '');
   const [target_config, setTargetConfig] = useState(() => '');


   const get_ad_services = async () => {
      try {
         // console.warn('>>> get_ad_services <<<');
         await Wait_For_Auth(SME_AUTH, true);
         // console.warn('>>> get_ad_services SPORT_BASE: ', SPORT_BASE);
         const club = await dbHandler.load_club();
         const club_id = parseInt(club.club_id);
         const authResult = await SME_AUTH.is_authenticated();
         if (!authResult) {
            return;
         }
   
         const tc_id = SPORT_BASE.sport_object.scoring.state.match.push_match.tc_id;
         // console.warn('[DEBUG-ADIMAGE] club_id: ', club_id);
         // console.warn('[DEBUG-ADIMAGE] tc_id: ', tc_id);
   
         const club_config = {
            target_type: "club_sport",
            club_id: club_id,
            sport_type: SPORT_BASE.sport_name,         
         }
   
         const tournament_config = {
            target_type: "tournament",
            tc_id: tc_id,
         }
         
   
         const config = tc_id === 0 ? club_config : tournament_config;
         // console.log('target_config: ', config);
  
         
         setGraphql(SME_AUTH.get_graphql());
         setAPI(SME_AUTH.get_api());
         setTargetConfig(config);
      } catch (error) {
         console.error('ERROR - get_ad_services: ', error);
      }
   }


   useEffect(() => {
      if (isVisible === true) {
         // console.log('AdImage - isVisible');
         get_ad_services();
      } else {
         // console.log('AdImage - isNotVisible');
      }
   }, [isVisible]);


   // const [ad_image_timer, _setADTimer] = useState(() => new Loop_Timer('ad_image_timer', 15));
   // const load_images = () => {
   //    return new Promise(async (resolve) => {
   //       const club = await dbHandler.load_club();
   //       // console.log('[AdImage] load_images: ', );
   //       const ad_images = SPORT_BASE?.sport_object?.scoring?.state?.match?.push_match?.ad_images ?? [];
   //       // console.log('ad_images: ', ad_images);
   //       // console.log('ad_images.length: ', ad_images.length);
   //       if (ad_images.length > 2) {
   //          const list = [
   //             {
   //                img: ad_images[0],
   //                timer: 15,
   //             },
   //             {
   //                img: ad_images[1],
   //                timer: 10,
   //             },
   //             {
   //                img: ad_images[2],
   //                timer: 5,
   //             },
   //             {
   //                img: club?.club_logo,
   //                timer: 5,
   //             },
   //          ];
   //          image_list = list;
   //          resolve(true);
   //       } else if (typeof club !== 'undefined') {
   //          // console.log('Load Ad Images from Club: ', club);
   //          const list = [
   //             {
   //                img: club.ad_1.substring(3),
   //                timer: 15,
   //             },
   //             {
   //                img: club.ad_2.substring(3),
   //                timer: 10,
   //             },
   //             {
   //                img: club.ad_3.substring(3),
   //                timer: 5,
   //             },
   //             {
   //                img: club.club_logo,
   //                timer: 5,
   //             },
   //          ];
   //          image_list = list;
   //          resolve(true);
   //       }
   //    })
   // }
   // const init = async () => {
   //    var img_index = 1;
   //    const cycle_ad = () => {
   //       if (typeof image_list[img_index] !== 'undefined') {
   //          setImage(image_list[img_index].img);
   //          ad_image_timer.set_interval(image_list[img_index].timer);
   //       }
   //       img_index++;
   //       if (img_index > image_list.length-1) {
   //          img_index = 0;
   //       }
   //    }
   //    // if (image_list.length === 0) { await load_images(); }
   //    await load_images();
   //    if (typeof image_list[0] !== 'undefined') {
   //       setImage(image_list[0].img);
   //       ad_image_timer.set_interval(image_list[0].timer);
   //    }
   //    ad_image_timer.start(() => { cycle_ad(); });
   // }
   // useEffect(() => {
   //    if (isVisible === true) {
   //       init();
   //    } else {
   //       ad_image_timer.stop();
   //    }
   // }, [isVisible]);

   return (<div className={style.wrap} ref={wrapper}>
      {/* <RemoteImage src={image} alt="Ad Image" className={style.adImage} /> */}
      <AdDisplayTool
         services={{ api: api, graphql: graphql }}
         target={target_config}
         imageStyle={{
            borderRadius: 'var(--base-border-radius)',
         }}
      />
   </div>);
}

export default AdImage;


